import PointCutTable from "./pointCutTable.container";

export default PointCutTable;
